import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';
import Link from 'next/link';
import React from 'react';

import FeatureLink from '../../ui/links/featured';

const LegalInfo = () => {
  const { t } = useTranslation();
  return (
    <div className="text-sm  text-justify">
      <h2 className="font-bold text-xl pt-12">{t('legal:info.title1')}</h2>
      <Trans
        i18nKey="legal:info.text1"
        components={{ p: <p className="pt-3" />, br: <br /> }}
      />

      <h2 className="font-bold text-xl pt-12">{t('legal:info.title2')}</h2>
      <Trans
        i18nKey="legal:info.text2"
        components={{
          p: <p className="pt-3" />,
          br: <br />,
          link: (
            <Link
              href="https://www.google.com/analytics"
              passHref
              legacyBehavior
            >
              <FeatureLink target="_blank">
                https://www.google.com/analytics
              </FeatureLink>
            </Link>
          ),
        }}
      />

      <h2 className="font-bold text-xl pt-12">{t('legal:info.title3')}</h2>
      <Trans
        i18nKey="legal:info.text3"
        components={{
          p: <p className="pt-3" />,
          br: <br />,
          b: <b />,
          link: (
            <FeatureLink
              href="https://ec.europa.eu/consumers/odr/"
              target="_blank"
            >
              {t('legal:info.here_link')}
            </FeatureLink>
          ),
        }}
      />
    </div>
  );
};
export default LegalInfo;
